import "./Blocks.css";
import React from "react";
import { Visit } from "../Components/Visit";
import { Timetable } from "../Components/Timetable";
import { Location } from "../Components/Location";
import { Pictures } from "../Components/Pictures";

export const Blocks = () => {
    return (
        <div id="blocks">
            <Visit />
            <Timetable />
            <Location />
            <Pictures />
        </div>
    );
};
